import { TermsOfService } from '../components/policy-modal';
import { Footer } from '../components/footer';
import { Camp67Header } from '../components/camp67-header/camp67-header';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Terms of Service - camp67' },
    {
      name: 'description',
      content: 'View our terms of service, including privacy and reseller policies.',
    },
    {
      tagName: 'link',
      name: 'canonical',
      href: 'https://camp67.com/terms-of-service',
    },
  ];
};

export default function TermsOfServicePage() {
  return (
    <>
      <div className="bg-yellow-50">
        <div className="m-auto w-full rounded-b-md border-dotted border-b-black border-b pb-7">
          <Camp67Header isLogoLight={false} isDarkGlowHidden={true} textColor="dark" />
        </div>
        <main className="w-full xl:px-72 lg:px-72 md:px-20 px-10 py-20">
          <section>
            <TermsOfService />
          </section>
        </main>
      </div>
      <Footer isHome={false} />
    </>
  );
}
